import { getApiKey } from "../../../utils/apiKey";
import React from "react";
import { createGlobalStyle } from "styled-components";
import { apiCall_domainV2 } from "../../api";
import axios from "axios";
import Spinner from "../../Spinner/Spinner";
import Header from "../../header";

export class Scores extends React.Component {
  state = {
    changeDetail: true,
    activeTab: 1,
    mainContent: true,
    filterShow: false,
    aboutPoints: false,
    data: [],
    spentData: [],
    recieveData: [],
    loading: true,
  };

  pointHistoryHandler = (tab) => {
    this.setState({
      activeTab: tab,
    });
  };

  AboutModalHandler = () => {
    this.setState({
      filterShow: false,
      mainContent: false,
      aboutPoints: true,
    });
  };
  backBtn = () => {
    this.props.history.goBack();
  };
  // api call
  componentDidMount() {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domainV2}/customer/market/points`, {
        headers: headers,
      })
      .then((res) => {
        this.setState({ loading: false, data: res.data });
      });
  }
  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #262626 !important;
    }`;
    return (
      <div>
        <div className="scoresContainer">
          <GlobalStyles />
          {this.state.loading ? (
            <Spinner />
          ) : (
            <>
              {this.state.mainContent && (
                <div className="scoresContainerContent">
                  <Header
                    showSearchBar={true}
                    title="امتیازات"
                    isDarkTheme={true}
                    changeDetail={true}
                  />
                  <div className="scoresBody">
                    <>
                      <div className="scoresBodyHeader">
                        <h4>تاریخچه امتیازات </h4>
                      </div>
                      <div className={`scoreDivs `}>
                        {this.state.data.points.length ? (
                          this.state.data.points.map((item) => {
                            return (
                              <div
                                className="scoreDiv"
                                key={item.id}
                                style={
                                  item.coefficient == 1
                                    ? { borderRight: "6px solid #f7a600" }
                                    : { borderRight: "6px solid #ff4c4c" }
                                }
                              >
                                <div className="scoreOrigin">
                                  <span>{item.points}</span>
                                  <span>{item.type}</span>
                                </div>
                                <div className="scoredHour">
                                  <span>{item.created_at}</span>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <span className="noDataMsg">
                            تا کنون امتیازی کسب یا خرج نشده است
                          </span>
                        )}
                      </div>
                    </>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}
// custom tabs
